import logo from '../../assets/logo.svg';
import React, {useEffect, useState} from "react";
import useApi from "../../utils/useApi";
import {ThemeProvider} from "../ThemeContext/ThemeContext";
import AppRouter from "../../routes/AppRouter";
import authApi from "../../utils/auth.api";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import styles from "./App.module.css";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Uncaught error:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return <h1>Something went wrong.</h1>;
        }

        return this.props.children;
    }
}



function App() {
    const { isLoading, error } = useApi();
    const [user, setUser] = useState(null);

    useEffect(() => {
        // Hide splash screen
        const splashScreen = document.getElementById('splash-screen');
        if (splashScreen) {
            splashScreen.classList.add('hidden');
            setTimeout(() => {
                splashScreen.style.display = 'none';
            }, 1000); // Match this to your CSS transition time
        }
    }, []);

    if (error) {
        return <div>Error: {error}</div>;
    }

    const getUser = () => {
        const currentUser = authApi.getCurrentUser();
        if (currentUser) {
            setUser(currentUser);
        }
    }

    return (
        <ErrorBoundary>
            <ThemeProvider>
                <div id="MainApp">
                    {!isLoading ? (
                        <AppRouter
                            user={user}
                        />
                    ) : (
                         <LoadingScreen />
                     )}
                </div>
            </ThemeProvider>
        </ErrorBoundary>
    );
}

export default App;
